import ProvidersDirectory from "@/components/ProvidersDirectory";
import { fetchTowTrucks } from "@/lib/api";

const SPECIALTIES = [
  "Flatbed", "Wheel-lift", "Motorcycle", "Long Distance", "Jump Start",
  "Lockout", "Fuel Delivery", "Tire Change", "Heavy Duty", "Off-road Recovery",
];

export default function TowTrucksPage() {
  return (
    <ProvidersDirectory
      title="24/7 Tow & Roadside"
      subtitle="Round-the-clock recovery operators dispatched by ETA. Every provider below is on-call right now."
      fetcher={fetchTowTrucks}
      specialties={SPECIALTIES}
      testIdPrefix="tow"
      defaultSort="response_time"
    />
  );
}
